import useLeadListSources from "../datahooks/useLeadListSources";

/** Where the list's mining stands, derived from the state of its sources. */
export default function useLeadListUpdateStatus({
  listId,
}: {
  listId: string;
}) {
  const { leadListSources } = useLeadListSources({ listId });

  const sources = leadListSources ?? [];
  //the most recent run across every source - one that hasn't completed a run
  //yet may not have last_mined_at set at all
  const lastUpdatedAt = sources.reduce<string | undefined>(
    (latest, { last_mined_at: lastMinedAt }) => {
      if (lastMinedAt) {
        if (!latest) {
          return lastMinedAt;
        }
        return new Date(lastMinedAt) > new Date(latest) ? lastMinedAt : latest;
      }
      return latest;
    },
    undefined,
  );

  return {
    //a source that's still discovering urns or hydrating profiles keeps the
    //whole list updating
    isUpdating: sources.some(
      ({ state }) => state === "STARTED" || state === "ENRICHING",
    ),
    lastUpdatedAt,
  };
}
